import { HOME_QUERY, CATEGORY_QUERY } from '../queries';
import query from '../utils/grappa';
import { ARTICLES_FETCH_SIZE } from './article';
export async function fetchHome(languageId) {
    const res = await query(HOME_QUERY, {
        pageUrl: window.location.toString(),
        languageId,
        paging: {
            first: 5,
            offset: 0,
        },
    });
    return res;
}
export async function fetchCategory(categoryId, languageId) {
    const res = await query(CATEGORY_QUERY, {
        categoryId,
        pageUrl: window.location.toString(),
        languageId,
        paging: {
            first: ARTICLES_FETCH_SIZE,
            offset: 0,
        },
    });
    return res;
}
//# sourceMappingURL=category.js.map